/**
 * Tab controller 
 * @author Erik Bánhalmi 2017.03.24.
 */
import tabSetTemplate from './M10-tabset.pug';

import 'angular-ui-bootstrap';

const MODULE_NAME = 'tabSet';
class TabSetController {
	constructor($uibModal, $scope) {
		'ngInject';
		this._$uibModal = $uibModal;
		this.$scope = $scope;
	}
	$onInit() {
		this.activeTab = 0;
		
	}	
	
	tabTitleClick(e, number) {
		e.preventDefault();
		this.activeTab = number;
	}
	handleArrows(e) {
		if (e.keyCode == 37 || e.keyCode == 39)	{
			if (e.keyCode == 37) {
				this.activeTab--;
				if (this.activeTab < 0) {
					this.activeTab = angular.element(document.getElementsByClassName('js-tab-content')).length-1;
				}
			} else if (e.keyCode == 39) {
				this.activeTab++;
				if (this.activeTab >= angular.element(document.getElementsByClassName('js-tab-content')).length) {
					this.activeTab = 0;
				}
			}
		}
	}
}

export default angular.module(MODULE_NAME, [])
	.component('tabSet', {
		transclude: {
			'titleSlot': 'ul',
			'contentSlot': 'div'
		},
		template: tabSetTemplate(),
		controller: TabSetController,
		bindings: {
			tabContent: '@'
		}
	}).name;



// WEBPACK FOOTER //
// ../source/modules/M10-tab/M10-tab.js